export default "__VITE_ASSET__1uIx1kmQ__"